import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxInputMultiple',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    value: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;

  const isChecked = computed(() => {
    return props.modelValue.includes(props.value);
  });
  const check = () => {
    let updatedNames = [...props.modelValue];

    if (isChecked.value) {
      updatedNames.splice(updatedNames.indexOf(props.value), 1);
    } else {
      updatedNames.push(props.value);
    }

    emits("update:modelValue", updatedNames);
  };

const __returned__ = { props, emits, isChecked, check, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})